export default "__VITE_ASSET__5f492e5b__"